import React from "react";
import ReactDOM from "react-dom";
// import "react-tabs/style/react-tabs.css";
// import './tailwind.output.css';
import "./index.css";
import App from "./App";
import * as serviceWorker from "./serviceWorker";
import GlobalState from "./useGlobalState";
ReactDOM.render(
  <GlobalState.Provider>
    <App />
  </GlobalState.Provider>,
  document.getElementById("root")
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.register();
